
import { Component } from 'vue-property-decorator';
import SettingBase from './SettingBase';

@Component
export default class SettingBoolean extends SettingBase { }
